<template>
    <b-card>
        <!-- filter  -->
        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="col-12 mt-16">
            <div>
                <b-row class="align-items-center">
                    <b-col lg="6" class="my-1">
                        <b-form-group label="" label-for="filter-input" label-cols-sm="1" label-align-sm="right"
                            label-size="sm" class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="filter-input" v-model="filter" type="search"
                                    placeholder="Type to Search"></b-form-input>
                                <b-input-group-append>
                                    <b-button @click="applyFilter" :disabled="!filter"
                                        variant="primary">Apply</b-button>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-row class="align-items-center justify-content-end">
                        <b-col class="d-flex justify-content-end">
                            <b-button v-b-tooltip.hover title="Manually record the order or enter the services delivered." @click="addorder" variant="primary" class="mr-2">Add Order Manually</b-button>
                            <b-button @click="exportAllDataToCSV" variant="primary">Export</b-button>
                        </b-col>
                    </b-row>
                </b-row>
            </div>
        </div>
        <!-- filter end -->
        <b-row>
            <div class="col-12 mt-16">
                <b-skeleton-table
                    v-if="loading"
                    :rows="perPage"
                    :columns="fields.length"
                    animation="wave"
                    bordered
                    class="mb-3"
                    />
                <b-table v-else id="dataTable" :items="users" :busy.sync="loading" :fields="fields" :current-page="currentPage"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty responsive striped hover  class="custom-zebra">
                    <template #cell(status)="row">
                    <b-button v-b-tooltip.hover title="Change Order Status Confirmation Pending or Approved" @click="handleButtonClick(row.item)"
                        :variant="row.item.status === 'Pending' ? 'warning' : 'primary'" class="mb-8 mr-8">
                        {{ row.item.status }}
                    </b-button>
                    
                    <b-modal v-model="showPaymentConfirmation" title="Change Order Status Confirmation">
                        <p>Are you sure you want to change status to {{ newPaymentStatus }}?</p>
                        <b-spinner v-if="loading" label="Processing..."></b-spinner>
                        <template #modal-footer>
                        <b-button :disabled="loading" variant="primary" @click="confirmPaymentStatus">Confirm</b-button>
                        <b-button :disabled="loading" variant="primary" @click="cancelPaymentStatus">Cancel</b-button>
                        </template>
                    </b-modal>
                    </template>

                    <template #cell(actions)="row">
                        <b-button  v-b-tooltip.hover title="Show Order details"  v-if="row.item.product" @click="showDrivers(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" style="
                color: rgba(0, 255, 195, 0.87);
                margin-left: 6px;
                margin-bottom: 10px;
              " class="bi bi-eye" viewBox="0 0 16 16">
                                <path
                                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path
                                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                            </svg>
                        </b-button>
                        <!-- delete -->
                        <b-button v-b-tooltip.hover title="Delete Order" @click="showDeleteConfirmation(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                style="color: red; margin-left: 6px; margin-bottom: 10px" class="bi bi-eye"
                                viewBox="0 0 16 16">
                                <!-- ... your SVG path ... -->
                                <path
                                    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                        </b-button>
                        <b-modal v-model="showDeleteConfirmations" title="Delete Confirmation">
                            <p>Are you sure you want to delete this item?</p>
                            <template #modal-footer>
                                <b-button variant="primary" @click="deleteItem(itemIdToDelete)">Delete</b-button>
                                <b-button variant="primary" @click="showDeleteConfirmations = false">Cancel</b-button>

                            </template>
                        </b-modal>
                        <!-- end delete -->

                    </template>
                           <!-- image  show code here  -->
                           <template #cell(image)="row">
                        <img :src="'https://wossdb.wossautoid.com/' + row.item.image" alt="Picture" width="100"
                            height="100" />
                    </template>
                    <!-- .................  -->
                      
                    <template #cell(product_name)="row">
                        <!-- {{ `${row.item.product.name} ` }} -->
                        {{ row.item.product?.name || row.item.service_type || 'N/A' }}
                    </template>
                   
                    <template #cell(user_name)="row">
                    {{ row.item.user?.first_name }} {{ row.item.user?.last_name }} {{ row.item.contact_person }}
                    </template>

                    <template #cell(email)="row">
                    {{ row.item.user?.email ||row.item.email ||'N/A' }}
                    </template>

                    <template #cell(phone_number)="row">
                    {{ row.item.user?.phone_number || 'N/A' }}
                    </template>

                    <template #cell(quantity)="row">
                    {{ row.item.quantity || 'N/A' }}
                    </template>

                    <template #cell(amount)="row">
                    {{ row.item.amount || 'N/A' }}
                    </template>

                    <template #cell(address)="row">
                        <div>
                            <div v-if="row.item.address">
                                <div>{{ row.item.address.address || '' }}</div>
                                <div>{{ row.item.address.apartment || '' }}</div>
                                <div>{{ row.item.address.city || '' }}, {{ row.item.address.state || '' }}</div>
                                <div>{{ row.item.address.country || '' }} {{ row.item.address.zip_code || '' }}</div>
                            </div>
                            <div v-else>
                                {{ row.item.address }}
                            </div>
                        </div>
                    </template>
                    <template #cell(payment_status)="row">
                    {{ row.item.payment_status || 'N/A' }}
                    </template>
                    <template #cell(payment_method)="row">
                    {{ row.item.payment_method || 'N/A' }}
                    </template>
                    <!-- ...............  -->

                    <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3" label-align-sm="right"
                        label-size="sm" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter" type="search"
                                placeholder="Type to Search"></b-form-input>

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-table>
                <div class="mx-8 d-flex justify-content-end">
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage"
                        aria-controls="dataTable" @change="pageChanged"></b-pagination>
                </div>
                <b-row class="mt-16 align-items-center justify-content-end">

                    <b-row>

                    </b-row>
                </b-row>
            </div>
        </b-row>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BInputGroupAppend,
    BSpinner,
    BModal,
    BSkeleton,
    BSkeletonTable,
} 
from "bootstrap-vue";
// import axios from "axios";
import axios from "../../../axios";
import Papa from "papaparse";

export default {
    data() {
        return {
            perPage: 20,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            lastPage: 0,
            firstPageUrl: null,
            lastPageUrl: null,
            nextPageUrl: null,
            prevPageUrl: null,
            isLoading: false,
            users: [],
            fields: [
                { key: "id", sortable: true },
                { key: "product_name", sortable: true },
                { key: "user_name", sortable: true },
                { key: "email", sortable: true },
                { key: "contact_number", label:"Cell Phone Number", sortable: true },
                { key: "address", sortable: true },
                { key: "quantity", sortable: true },
                { key: "amount", sortable: true },
                { key: "status",label:"Order Status", sortable: true },
                { key: "payment_status",label:"Payment Status", sortable: true },
                { key: "payment_method",label:"Payment Method", sortable: true },
                { key: "actions", label: "Actions" },
            ],

            filter: "", 
            total: 0, 
            showDeleteConfirmations: false,
            itemIdToDelete: null,
            loading: false,
            showPaymentConfirmation: false,
            modalVisible: false,
            newPaymentStatus: '',
        };

    },

    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BTable,
        BFormGroup,
        BInputGroup,
        BFormInput,
        BFormSelect,
        BPagination,
        BInputGroupAppend,
        BSpinner,
        BModal,
        BSkeleton,
        BSkeletonTable,

    },
    computed: {
        sortOptions() {
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => {
                    return { text: f.label, value: f.key };
                });
        },
        rows() {
            return this.users.length;
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        clearFilter() {
            this.filter = '';     
            this.currentPage = 1;   
            this.fetchData();       
        },
        async fetchData() {
            this.loading = true;
            let apiUrl = "Order";
            try {
                const response = await axios.post(apiUrl, {
                    params: { page: this.currentPage, per_page: this.perPage }
                });

                this.users = response.data.data;
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
                this.perPage = response.data.per_page;
                this.lastPage = response.data.last_page;
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                this.loading = false;
            }
        },
        applyFilter() {
            this.loading = true;
            let apiUrl = "Order";
            axios
                .post(apiUrl, {
                    params: {
                        search: this.filter,
                    },
                })
                .then((response) => {
                    this.users = response.data.data;
                    this.total = response.data.total;
                    this.currentPage = response.data.current_page;
                })
                .catch((error) => {
                    console.error("Error applying filter:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        pageChanged(newPage) {
            this.currentPage = newPage;
            this.fetchData();
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },
        exportAllDataToCSV() {
            this.fetchAllParents((allParents) => {
                const csv = Papa.unparse(allParents);
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "exported_data.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        fetchAllParents(callback) {
            axios
                .get("Orderforexport", { params: { per_page: this.totalRows } })
                .then((response) => {
                    callback(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching all Data:", error);
                });
        },

        editUser(userId) {
            this.$router.push({ name: "EditOrder", params: { id: userId } });
        },

        showDrivers(userId) {
            this.$router.push({ name: "ViewOrder", params: { id: userId } });
        },
        ///  delete
        showDeleteConfirmation(itemId) {
            this.itemIdToDelete = itemId;
            this.showDeleteConfirmations = true;
        },
        deleteItem(itemId) {

            this.itemIdToDelete = itemId; 
            axios
                .delete(`OrderDelete/${itemId}`)
                .then((response) => {
                    this.showDeleteConfirmations = false;
                    this.fetchData(); 
                })
                .catch((error) => {
                    // Handle error
                    console.error("Error deleting item:", error);
                });
        },

        cancelPaymentStatus() {

        this.showPaymentConfirmation = false;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        },

        handleButtonClick(item) {
        this.updateStatus(item);
        this.toggleCardModal(item);
      },
      handleButtonClick(item) {
        this.newPaymentStatus = item.status === 'Pending' ? 'Approved' : 'Pending';
        this.rowToUpdate = item;
        this.showPaymentConfirmation = true;
      },
  
      confirmPaymentStatus() {
        this.loading = true; 
        this.rowToUpdate.status = this.newPaymentStatus;
        axios
          .post(`OrderUpdateStatus/${this.rowToUpdate.id}`, { status: this.newPaymentStatus })
          .then((response) => {
            this.showPaymentConfirmation = false;
          })
          .catch((error) => {
       
            this.showPaymentConfirmation = false;
          })
          .finally(() => {
            this.loading = false; 
          });
      },
       addorder() {
            this.$router.push({ name: "AddOrder" });
        },
    },
};
</script>
  <style>
  /* Zebra striping */
  .custom-zebra tbody tr:nth-of-type(odd) {
    background-color: #f0f2f5; /* darker than default */
  }

  /* Hover effect */
  .custom-zebra tbody tr:hover {
    background-color: #e0e4ea !important; /* slightly darker hover */
  }
  </style>